// components/ColorPicker.tsx
import { useState } from 'react';
import { ColorPickerProps } from '../../types'

const ColorPicker: React.FC<ColorPickerProps> = ({ value, onCancel, onSave }) => {
    const [tempValue, setTempValue] = useState(value);

    const handleSave = () => {
        onSave(tempValue.toUpperCase());
    };

    const handleCancel = () => {
        setTempValue(value);
        onCancel();
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
            <div className="w-full max-w-sm rounded-lg bg-white p-6 shadow-xl mx-4">
                <h3 className="mb-4 text-lg font-semibold">Select Color</h3>
                <div className="mb-6 flex justify-center">
                    <input
                        type="color"
                        value={tempValue.toLowerCase()}
                        onChange={(e) => setTempValue(e.target.value)}
                        className="h-64 w-64 cursor-pointer rounded-lg border-2 border-gray-300"
                    />
                </div>
                <div className="mb-6 text-center">
                    <span className="font-medium">Current: </span>
                    <span className="font-mono text-lg">{tempValue.toUpperCase()}</span>
                </div>
                <div className="flex justify-end gap-3">
                    <button
                        onClick={handleCancel}
                        className="rounded-md border border-gray-300 px-4 py-2 text-gray-700 hover:bg-gray-100"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSave}
                        className="rounded-md bg-blue-600 px-4 py-2 text-indigo-600 hover:bg-blue-700"
                    >
                        Save
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ColorPicker;